import { useEffect, useState } from "react";

// Maximum prompt length accepted by Prompt Management.
const FIG2_PROMPT_MAX_LENGTH = 28000;
const PROMPT_MAX_LENGTH = 31000;

const getPromptMaxLength = (draftSection) =>
  /\bfig(?:ure)?\s*2\b/i.test(draftSection || "")
    ? FIG2_PROMPT_MAX_LENGTH
    : PROMPT_MAX_LENGTH;
import { Eye, Pencil, Trash2 } from "lucide-react";
import "../../styles/settings/PromptManagement.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const PromptManagement = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");

  const [addPrompt, setAddPrompt] = useState(null);
  const [editingPrompt, setEditingPrompt] = useState(null);
  const [viewPrompt, setViewPrompt] = useState(null);
  const [error, setError] = useState("");

  const activeTab = "OPENAI";

  /* ================= FETCH PROMPTS ================= */
  // const fetchPrompts = async () => {
  //   try {
  //     const res = await fetch(`${API_BASE}/admin/prompts`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });
  //     const data = await res.json();
  //     if (!res.ok) throw new Error(data.message);
  //     setPrompts(data);
  //   } catch (err) {
  //     alert(err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchPrompts = async () => {

  try {

    const res = await fetch(
      `${API_BASE}/admin/prompts?prompt_type=${activeTab}`,
      {
        method: "GET",

        headers: {
          Authorization:
            `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message);
    }

    setPrompts(data);

  } catch (err) {

    alert(err.message);

  } finally {

    setLoading(false);
  }
};

  useEffect(() => {
    fetchPrompts();
  }, [activeTab]);

  /* ================= TOGGLE STATUS ================= */
  const toggleStatus = async (prompt) => {
    await fetch(`${API_BASE}/admin/prompts/${prompt.prompt_id}/status`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        prompt_status: !prompt.prompt_status,
      }),
    });
    fetchPrompts();
  };

  /* ================= ADD PROMPT ================= */
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddPrompt((p) => ({ ...p, [name]: value }));
  };

  const saveAddPrompt = async () => {
    setError("");
    // const res = await fetch(`${API_BASE}/admin/prompts`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${localStorage.getItem("token")}`,
    //   },
    //   body: JSON.stringify({
    //     ...addPrompt,
    //     prompt_type: activeTab,
    //     prompt_status: true,
    //   }),
    // });

    if (
  !addPrompt.prompt_seq_no ||
  !addPrompt.prompts ||
  !addPrompt.draft_section
) {
  setError("All fields are required");
  return;
}

    if (addPrompt.prompts.length > getPromptMaxLength(addPrompt.draft_section)) {
      setError("Limit exceeded");
      return;
    }

    const res = await fetch(
  `${API_BASE}/admin/prompts`,
  {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      Authorization:
        `Bearer ${localStorage.getItem("token")}`,
    },

    body: JSON.stringify({
      ...addPrompt,
      prompt_type: activeTab,
      prompt_status: true,
    }),
  }
);

    if (!res.ok) {
      const data = await res.json();
      setError(data.message);
      return;
    }

    setAddPrompt(null);
    fetchPrompts();
  };

  /* ================= EDIT PROMPT ================= */
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingPrompt((p) => ({ ...p, [name]: value }));
  };

  const saveEditPrompt = async () => {
    setError("");

    if (editingPrompt.prompts.length > getPromptMaxLength(editingPrompt.draft_section)) {
      setError("Limit exceeded");
      return;
    }

    const res = await fetch(
      `${API_BASE}/admin/prompts/${editingPrompt.prompt_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          prompt_seq_no: editingPrompt.prompt_seq_no,
          prompts: editingPrompt.prompts,
          draft_section: editingPrompt.draft_section,
          prompt_type: activeTab,
        }),
      }
    );


    if (!res.ok) {
      const data = await res.json();
      setError(data.message);
      return;
    }

    setEditingPrompt(null);
    fetchPrompts();
  };

// /* ================= DELETE PROMPT ================= */
// const deletePrompt = async (promptId) => {

//   if (!window.confirm("Delete this prompt?")) return;

//   try {

//     await fetch(
//       `${API_BASE}/admin/prompts/${promptId}`,
//       {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     fetchPrompts();

//   } catch (err) {

//     alert("Delete failed");
//   }
// };
 

  /* ================= FILTER ================= */
  const filteredPrompts = prompts.filter((p) => {
    if (!statusFilter || statusFilter === "All") return true;
    if (statusFilter === "Active") return Boolean(p.prompt_status);
    if (statusFilter === "Inactive") return !Boolean(p.prompt_status);
        return true;
      });

  if (loading) return <p>Loading prompts...</p>;

  return (
    <div className="settings-page">
      {/* HEADER */}
      <div className="settings-header">
        <h2>Prompt Management</h2>
        <button
          className="primary-btn"
          onClick={() => {
            setError("");
            setAddPrompt({ prompt_seq_no: "", prompts: "", draft_section: "" });
          }}
        >
          + Add Prompt
        </button>
      </div>

      {/* FILTER */}
      <div className="filters">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>

      <div className="prompt-tabs">
        <button className="active">OpenAI Prompts</button>
      </div>

      {/* TABLE */}
      <table className="settings-table">
        <thead>
          <tr>
            <th>Seq</th>
            <th>Prompt</th>
            <th>Draft Section</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredPrompts.map((p, index) => (
            <tr key={p.prompt_id}>
              <td>{index + 1}</td>
              <td className="truncate">{p.prompts.slice(0, 80)}</td>
              <td>{p.draft_section}</td>

              {/* ✅ TOGGLE */}
              <td>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={p.prompt_status}
                    onChange={() => toggleStatus(p)}
                  />
                  <span className="slider"></span>
                </label>
              </td>

              <td className="actions">
                <button onClick={() => setViewPrompt(p)}>
                  <Eye size={16} />
                </button>
                <button onClick={() => { setError(""); setEditingPrompt(p); }}>
                  <Pencil size={16} />
                </button>
                {/* <button onClick={() => deletePrompt(p.prompt_id)}>
                  <Trash2 size={16} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ADD MODAL */}
      {addPrompt && (
        <Modal title="Add Prompt">
          <input
  name="prompt_seq_no"
  placeholder="Sequence"
  value={addPrompt.prompt_seq_no}
  onChange={handleAddChange}
/>

<textarea
  name="prompts"
  placeholder="Prompt"
  value={addPrompt.prompts}
  onChange={handleAddChange}
  rows={5}
  style={{ width: "100%", resize: "vertical" }}
/>

<input
  name="draft_section"
  placeholder="Draft Section"
  value={addPrompt.draft_section}
  onChange={handleAddChange}
/>
          {error && <p className="error-text">{error}</p>}
          <div className="modal-actions">
            <button className="primary-btn" onClick={saveAddPrompt}>Save</button>
            <button className="secondary-btn" onClick={() => { setError(""); setAddPrompt(null); }}>Cancel</button>
          </div>
        </Modal>
      )}

      {/* EDIT MODAL */}
      {editingPrompt && (
        <Modal title="Edit Prompt">
          <input name="prompt_seq_no" value={editingPrompt.prompt_seq_no} onChange={handleEditChange} />
		  <textarea
			  name="prompts"
			  value={editingPrompt.prompts}
			  onChange={handleEditChange}
			  rows={5}
			  style={{ width: "100%", resize: "vertical" }}
			/>
          <input name="draft_section" value={editingPrompt.draft_section} onChange={handleEditChange} />
          {error && <p className="error-text">{error}</p>}
          <div className="modal-actions">
            <button className="primary-btn" onClick={saveEditPrompt}>Save</button>
            <button className="secondary-btn" onClick={() => { setError(""); setEditingPrompt(null); }}>Cancel</button>
          </div>
        </Modal>
      )}

      {/* VIEW MODAL */}
      {viewPrompt && (
        <Modal title="Prompt Details">
          <div className="prompt-view-grid">
            <div className="label">Seq</div><div className="value">{viewPrompt.prompt_seq_no}</div>
            <div className="label">Prompt</div><div className="value">{viewPrompt.prompts}</div>
            <div className="label">Draft</div><div className="value">{viewPrompt.draft_section}</div>
            <div className="label">Status</div>
<div
  className={`value ${
    viewPrompt.prompt_status ? "status-active" : "status-inactive"
  }`}
>
  {viewPrompt.prompt_status ? "Active" : "Inactive"}
</div>

            
          </div>
          <div className="modal-actions center">
            <button className="secondary-btn" onClick={() => setViewPrompt(null)}>Close</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

/* MODAL */
const Modal = ({ title, children }) => (
  <div className="modal-overlay">
    <div className="modal-card">
      <h2>{title}</h2>
      {children}
    </div>
  </div>
);

export default PromptManagement;
